import { Link } from "react-router-dom"
import {Mail, MapPin, ArrowUpRight} from 'lucide-react'

const LOGO_URL = "https://static.lumi.new/4c/4c8f124f3e19139e5d5f616a0dcd86e1.png"

function Footer() {
  return (
    <footer className="text-white relative overflow-hidden" style={{ backgroundColor: "#050A14" }}>
      {/* Top CTA Bar */}
      <div style={{ borderColor: "#111D35" }} className="border-b">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
            <div className="max-w-xl">
              <h3 className="text-3xl sm:text-4xl font-bold mb-3 text-white">
                Ready to secure what matters?
              </h3>
              <p className="text-slate-400 text-lg">
                Get a free consultation and customized security plan today.
              </p>
            </div>
            <Link
              to="/contact"
              className="group flex items-center gap-3 px-8 py-4 bg-white text-gray-900 font-semibold tracking-wide rounded hover:bg-slate-200 transition-all"
            >
              GET STARTED
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="Sentrio Security"
                className="h-14 w-14 rounded-full object-cover"
              />
            </Link>
            <p className="text-slate-500 leading-relaxed text-sm max-w-xs">
              Professional security services across Canada and the USA. Protecting people, property, and assets since 2019.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] text-slate-300 uppercase mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {[
                "Uniformed Security",
                "Mobile Patrol",
                "Concierge Security",
                "Site Protection",
                "Loss Prevention",
                "CCTV Monitoring",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-slate-500 hover:text-white text-sm transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] text-slate-300 uppercase mb-6">
              Company
            </h4>
            <ul className="space-y-3">
              {[
                { label: "About Us", path: "/about" },
                { label: "Our Services", path: "/services" },
                { label: "Careers", path: "/careers" },
                { label: "Parking Appeals", path: "/appeals" },
                { label: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-500 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] text-slate-300 uppercase mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:info@sentriosecurity.com"
                  className="flex items-center gap-3 text-slate-500 hover:text-white text-sm transition-colors"
                >
                  <Mail className="w-4 h-4 text-slate-400 flex-shrink-0" />
                  info@sentriosecurity.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-500 text-sm">
                  North America
                  <br />
                  Serving Canada & USA
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderColor: "#111D35" }} className="border-t">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-600 text-xs tracking-wide">
              &copy; {new Date().getFullYear()} Sentrio Security. All rights reserved.
            </p>
            <div className="flex gap-6 text-xs tracking-wide">
              <Link
                to="/contact"
                className="text-slate-600 hover:text-slate-400 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/contact"
                className="text-slate-600 hover:text-slate-400 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
